/* eslint-disable ember/no-computed-properties-in-native-classes */
// Extending From
import Controller from '@ember/controller';
// Ember Imports
import { service } from '@ember/service';
// External imports
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { alias } from '@ember/object/computed';

export default class MyProfileController extends Controller {
  Jurisdiction = Jurisdiction;

  // Services
  @service
  session;

  // Computed attributes
  @alias('session.school.jurisdiction')
  jurisdiction;
}
